module.exports = __webpack_public_path__ + "img/Gunnar-Ploehn-500.fa2ab910.jpg";